import request, { authOptions } from 'api/requestUtils'
import type { definitions } from '@luxuryescapes/contract-svc-agent'

type VerifySocieteIdentityRequest = definitions['verifySocieteIdentityRequest']
type VerifySocieteIdentityResponse = {
  exists: boolean
  loyaltyAccountExists: boolean
  needConfirmation: boolean
}

export interface VerifySocieteIdentityParams {
  email?: string
  societeNumber?: string
  firstName: string
  lastName: string
}

async function requestPostVerifyAgentHubSocieteIdentity(params: VerifySocieteIdentityParams) {
  const requestBody: VerifySocieteIdentityRequest = {
    email: params.email,
    societeNumber: params.societeNumber,
    firstName: params.firstName,
    lastName: params.lastName,
  }

  const response = await request.post<App.ApiResponse<VerifySocieteIdentityResponse>, VerifySocieteIdentityRequest>(
    '/api/agent/user/societe/verify',
    requestBody,
    authOptions(),
  )

  return response.result
}

export default requestPostVerifyAgentHubSocieteIdentity
